import { RecomendacionesRaw, Recomendaciones } from "./types/recomendaciones";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchRecomendaciones(
  lang: Locale
): Promise<Recomendaciones[]> {
  const res = await fetchWithRetry<{ data: RecomendacionesRaw[] }>(
    `/recomendaciones?lang=${cmsLang(lang)}`
  );

  if (!res.data) {
    throw new Error("Failed to fetch recomendaciones");
  }

  return res.data.map((item) => ({
    id: item.id,
    nombre: item.nombre,
    banner: item.banner,
    contenido: item.contenido.map((subItem) => ({
      id: subItem.id,
      title: subItem.title,
      description: subItem.description,
      links: subItem.links.map((link) => ({
        href: link.href,
        label: link.label,
      })),
    })),
  }));
}
